import Theme from '@qnpm/q-theme';
const { font, color, layout, border, shape } = Theme;
const { scenes } = color;
const { buttonColors } = scenes;
const { button: buttonBorder } = border;
const { button: buttonLayout } = layout;
const { button: buttonShape } = shape;
const iconBaseStyle = {
    backgroundColor: 'transparent'
};
/* -------------- 样式属性 start -------------- */
function getComputedStyle(needScale) {
    const fontSize = needScale
        ? font.size.scaled
        : font.size.unscaled;
    const layoutSize = needScale
        ? buttonLayout.scaled
        : buttonLayout.unscaled;
    return {
        fontSize,
        layoutSize
    };
}
/**
 * 获取按钮圆角
 * @param size
 * @param needScale
 * @private
 */
function getBorderRadiusBySize(size, needScale) {
    const { wrapper } = getButtonSize(needScale)[size];
    const buttonHeight = (wrapper === null || wrapper === void 0 ? void 0 : wrapper.height) || 0;
    return Math.ceil(Number(buttonHeight) / 2);
}
// 按钮大小
const getButtonSize = (needScale) => {
    const { fontSize, layoutSize } = getComputedStyle(needScale);
    return {
        large: {
            wrapper: {
                borderWidth: buttonBorder.large,
                minWidth: layoutSize.minWidth.large,
                height: layoutSize.height.large,
                paddingHorizontal: layoutSize.paddingHorizontal.large
            },
            icon: {
                fontSize: fontSize.fontSizeX2L
            },
            text: {
                fontSize: fontSize.fontSizeXL,
                fontWeight: font.weight.fontWeightBold
            }
        },
        medium: {
            wrapper: {
                borderWidth: buttonBorder.medium,
                minWidth: layoutSize.minWidth.medium,
                height: layoutSize.height.medium,
                paddingHorizontal: layoutSize.paddingHorizontal.medium
            },
            icon: {
                fontSize: fontSize.fontSizeXL
            },
            text: {
                fontSize: fontSize.fontSizeL,
                fontWeight: font.weight.fontWeightBold
            }
        },
        small: {
            wrapper: {
                borderWidth: buttonBorder.small,
                minWidth: layoutSize.minWidth.small,
                height: layoutSize.height.small,
                paddingHorizontal: layoutSize.paddingHorizontal.small
            },
            icon: {
                fontSize: fontSize.fontSizeL
            },
            text: {
                fontSize: fontSize.fontSizeM,
                fontWeight: font.weight.fontWeightBold
            }
        },
        mini: {
            wrapper: {
                borderWidth: buttonBorder.mini,
                minWidth: layoutSize.minWidth.mini,
                height: layoutSize.height.mini,
                paddingHorizontal: layoutSize.paddingHorizontal.mini
            },
            icon: {
                fontSize: fontSize.fontSizeL
            },
            text: {
                fontSize: fontSize.fontSizeM
            }
        },
        mini_s: {
            wrapper: {
                borderWidth: buttonBorder.mini_s,
                minWidth: layoutSize.minWidth.mini_s,
                height: layoutSize.height.mini_s,
                paddingHorizontal: layoutSize.paddingHorizontal.mini_s
            },
            icon: {
                fontSize: fontSize.fontSizeM
            },
            text: {
                fontSize: fontSize.fontSizeS
            }
        },
        mini_xs: {
            wrapper: {
                borderWidth: buttonBorder.mini_xs,
                minWidth: layoutSize.minWidth.mini_xs,
                height: layoutSize.height.mini_xs,
                paddingHorizontal: layoutSize.paddingHorizontal.mini_xs
            },
            icon: {
                fontSize: fontSize.fontSizeM
            },
            text: {
                fontSize: fontSize.fontSizeS
            }
        }
    };
};
// 按钮类型
const buttonType = {
    normal: {
        wrapper: {
            borderColor: buttonColors.normalBorder,
            backgroundColor: buttonColors.white
        },
        icon: Object.assign({ color: buttonColors.normalText }, iconBaseStyle),
        text: {
            color: buttonColors.normalText
        }
    },
    primary: {
        wrapper: {
            borderColor: buttonColors.primaryBorder,
            backgroundColor: buttonColors.primaryBackground
        },
        icon: Object.assign({ color: buttonColors.white }, iconBaseStyle),
        text: {
            color: buttonColors.white
        }
    },
    ghost: {
        wrapper: {
            borderColor: buttonColors.normalBorder,
            backgroundColor: 'transparent'
        },
        icon: Object.assign({ color: buttonColors.normalText }, iconBaseStyle),
        text: {
            color: buttonColors.normalText
        }
    },
    dashed: {
        wrapper: {
            borderColor: buttonColors.normalBorder,
            borderStyle: 'dashed',
            backgroundColor: buttonColors.white
        },
        icon: Object.assign({ color: buttonColors.normalText }, iconBaseStyle),
        text: {
            color: buttonColors.normalText
        }
    },
    warning: {
        wrapper: {
            borderColor: buttonColors.priceBorder,
            backgroundColor: buttonColors.priceBackground
        },
        icon: Object.assign({ color: buttonColors.white }, iconBaseStyle),
        text: {
            color: buttonColors.white
        }
    }
};
// 按钮outline配置
const buttonOutline = {
    primary: {
        borderColor: buttonColors.primaryBorder,
        backgroundColor: buttonColors.white,
        fontColor: buttonColors.primaryText
    },
    warning: {
        borderColor: buttonColors.priceOutlineBorder,
        backgroundColor: buttonColors.white,
        fontColor: buttonColors.priceText
    }
};
// 按钮禁止
const buttonDisabled = {
    wrapper: {
        borderWidth: 0,
        borderColor: buttonColors.disableBorder,
        backgroundColor: buttonColors.disableBackground
    },
    icon: {
        color: buttonColors.disableText
    },
    text: {
        color: buttonColors.disableText
    }
};
// 镂空按钮禁止态
const buttonOutlineDisable = {
    wrapper: {
        borderColor: buttonColors.disableBorder,
        backgroundColor: 'transparent'
    },
    icon: {
        color: buttonColors.disableText
    },
    text: {
        color: buttonColors.disableText
    }
};
// 按钮形状
const getButtonShape = (needScale) => ({
    capsule: {
        large: {
            borderRadius: getBorderRadiusBySize('large', needScale)
        },
        medium: {
            borderRadius: getBorderRadiusBySize('medium', needScale)
        },
        small: {
            borderRadius: getBorderRadiusBySize('small', needScale)
        },
        mini: {
            borderRadius: getBorderRadiusBySize('mini', needScale)
        },
        mini_s: {
            borderRadius: getBorderRadiusBySize('mini_s', needScale)
        },
        mini_xs: {
            borderRadius: getBorderRadiusBySize('mini_xs', needScale)
        }
    },
    fillet: {
        large: {
            borderRadius: buttonShape.large
        },
        medium: {
            borderRadius: buttonShape.medium
        },
        small: {
            borderRadius: buttonShape.small
        },
        mini: {
            borderRadius: buttonShape.mini
        },
        mini_s: {
            borderRadius: buttonShape.mini_s
        },
        mini_xs: {
            borderRadius: buttonShape.mini_xs
        }
    },
    // 圆形不能有padding
    circle: {
        large: {
            borderRadius: getBorderRadiusBySize('large', needScale),
            paddingHorizontal: 0
        },
        medium: {
            borderRadius: getBorderRadiusBySize('medium', needScale),
            paddingHorizontal: 0
        },
        small: {
            borderRadius: getBorderRadiusBySize('small', needScale),
            paddingHorizontal: 0
        },
        mini: {
            borderRadius: getBorderRadiusBySize('mini', needScale),
            paddingHorizontal: 0
        },
        mini_s: {
            borderRadius: getBorderRadiusBySize('mini_s', needScale),
            paddingHorizontal: 0
        },
        mini_xs: {
            borderRadius: getBorderRadiusBySize('mini_xs', needScale),
            paddingHorizontal: 0
        }
    }
});
/* -------------- 样式属性 end -------------- */
// 按钮样式
const styles = {
    getButtonSize,
    buttonType,
    buttonOutline,
    buttonDisabled,
    buttonOutlineDisable,
    getButtonShape
};
export default styles;
